<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="editedMember"> {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <!-- <b-modal hide-footer id="invite-member" :title="$t('organization.invite')">
        <organization-invite-survey-member :disableRoles="true" :inviteButtonText="'Davet Et'" :organization="currentOrganization" @onSaved="reloadAccountFilter" />
      </b-modal> -->

      <sweet-input
        class="mt-2"
        :isValid="!$v.form.title.$error"
        @input="$v.form.$touch()"
        v-model="form.title"
        type="text"
        layout="vertical"
        inputClass="mt"
        :placeholder="$t('file-approval-survey.member.title')"
        :label="$t('file-approval-survey.member.title')"
      />

      <sweet-input
        class="mt-2"
        :isValid="!$v.form.unit.$error"
        v-model="form.unit"
        @input="$v.form.$touch()"
        type="text"
        layout="vertical"
        inputClass="mt"
        :placeholder="$t('file-approval-survey.member.unit')"
        :label="$t('file-approval-survey.member.unit')"
      />

      <h6 class="mt-2">{{ $t("file-approval-survey.member.assignee") }}</h6>

      <!-- <div @click="createSurveyParticipant()" class="text-primary hand text-right">{{ $t("file-approval-survey.member.create") }}</div> -->
      <organization-member-select
        :disabled="!!form._id"
        ref="organizationMemberSelect"
        @onSelect="onMemberSelect"
        :selected="form.assignee"
        :organization="currentOrganization"
        :filterFunction="filterFunction"
      />

      <sweet-input
        class="mt-2"
        :isValid="!$v.form.contact.$error"
        @input="$v.form.$touch()"
        v-model="form.contact"
        type="text"
        layout="vertical"
        inputClass="mt"
        :placeholder="$t('file-approval-survey.member.contact')"
        :label="$t('file-approval-survey.member.contact')"
      />

      <br />

      <sweet-button @click="save()" type="submit" :disabled="$v.form.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import OrganizationMemberSelect from "@cc/organization-member-select";
import OrganizationInviteSurveyMember from "./component/organization-invite-survey-member.vue";

import { required } from "vuelidate/lib/validators";

export default {
  props: { "hide-library": { type: Boolean }, closeOnSave: { type: Boolean, default: true } },
  components: {
    OrganizationMemberSelect,
    OrganizationInviteSurveyMember,
  },
  data() {
    return {
      form: { assignee: undefined, title: undefined, unit: undefined, contact: undefined, type: undefined },
      formError: undefined,
      entityName: undefined,
    };
  },
  validations: {
    form: {
      title: {
        required,
      },
      assignee: {
        required,
      },

      unit: {},

      contact: {},
    },
  },
  watch: {
    editedMember: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          const participant = this.prepareFormForEdit(v.participant, ["title", "unit"]);
          delete participant._id;

          this.form = { ...participant, _id: v._id };
        } else {
          this.form = {};
        }
      },
    },
  },
  computed: {
    isEditMode() {
      return this.$store.getters["organizationFileApprovalSurvey/isEditMode"];
    },
    file() {
      return this.$store.getters["fileManager/selectedEntity"];
    },
    editedMember() {
      return this.$store.getters["organizationFileApprovalSurvey/editedMember"];
    },
    fileAccessibleAccounts() {
      return this.$store.getters["organizationFileAccessibleAccounts/pagination"]?.docs || [];
    },
  },
  async mounted() {
    await this.$store.dispatch("organizationFileAccessibleAccounts/accessibleAccountsByFileId", {
      fileId: this.file._id,
      pagination: { options: { page: 1, limit: 500 } },
    });
  },
  methods: {
    filterFunction(item) {
      return this.fileAccessibleAccounts.some((i) => i.account._id == item.accountId && i.permissions.read);
    },

    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch(`organizationFileApprovalSurvey/saveMember`, { _id: this.form._id, member: { ...this.form, type: "MEMBER" }, file: this.file });
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-survey-participant");
        }
        setTimeout(() => this.$emit("onSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    reloadAccountFilter(item) {
      this.$root.$emit("bv::hide::modal", "invite-member");
      this.form = { ...this.form, assignee: { ...item, _id: item.accountId } };
      //this.$refs.organizationMemberSelect.init();
    },
    onMemberSelect(item) {
      this.form = { ...this.form, assignee: item };
      this.$v.form.assignee.$touch();
    },
    createSurveyParticipant() {
      this.$root.$emit("bv::show::modal", "invite-member");
    },
  },
};
</script>
